export enum GlTaxCodeGroupEnum {
  SALE = 'SALE',
  PURCHASE = 'PURCHASE',
  // OTHER = 'OTHER',
  // PRODUCT_TYPES = 'PRODUCT_TYPES',
}
